module.exports = __webpack_public_path__ + "static/media/23@2x.4ca96cc5.png";